import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { Link } from "react-router-dom";
import _ from "lodash";
class RozhanaMawadTable extends React.Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const {
              RDM_isSingle,
              RDM_dataWakelQarz,
              D_gotowaslrentsearch,
              RDM_harzantr,
              RDM_harzantr_IQD,
              GDM_grantr_IQD,
              GDM_grantr,
              GDM_isSingle
            } = value;
            const qarzeWakel = RDM_dataWakelQarz.filter((item) => {
              if (RDM_harzantr && item.currency == "دۆلار") {
                return (
                  Number(item.itemPrice) > Number(item.itemSale) &&
                  item.is_Single == false
                );
              }
              if (RDM_harzantr_IQD && item.currency == "دینار") {
                return (
                  Number(item.itemPriceDinar) > Number(item.itemSale) &&
                  item.is_Single == false
                );
              }
              if (RDM_isSingle && item.currency == "دینار") {
                return (
                  Number(item.singleSalePrice) > Number(item.itemSale) &&
                  item.is_Single == true
                );
              }
              if (GDM_grantr && item.currency == "دۆلار") {
                return (
                  Number(item.itemPrice) < Number(item.itemSale) &&
                  item.is_Single == false
                );
              }
              if (GDM_grantr_IQD && item.currency == "دینار") {
                return (
                  Number(item.itemPriceDinar) < Number(item.itemSale) &&
                  item.is_Single == false
                );
              }
              if (GDM_isSingle && item.currency == "دینار") {
                return (
                  Number(item.singleSalePrice) < Number(item.itemSale) &&
                  item.is_Single == true
                );
              }
              if (
                !RDM_harzantr_IQD &&
                !RDM_harzantr &&
                !GDM_grantr &&
                !GDM_grantr_IQD &&
                !GDM_isSingle &&
                !RDM_isSingle
              ) {
                return true;
              }
              return false;
            }).map((user, i) => {
              return (
                <tr
                  key={i}
                  className={`fk ${
                    RDM_harzantr_IQD ||
                    RDM_harzantr ||
                    GDM_grantr ||
                    GDM_grantr_IQD ||
                    GDM_isSingle ||
                    RDM_isSingle
                      ? "bg-secondary text-white"
                      : ""
                  }`}
                >
                  <td style={{ border: "2px solid #f0ad4e" }}>
                    {user.numberOfWakil}
                  </td>
                  <td style={{ border: "2px solid #f0ad4e" }}>{user.wakil}</td>
                  <td style={{ border: "2px solid #f0ad4e" }}>
                    {user.itemCarton}
                  </td>
                  <td style={{ border: "2px solid #f0ad4e" }}>
                    {" "}
                    <NumberFormat
                      value={
                        Number.isInteger(Number(user.proft))
                          ? Number(user.proft)
                          : Number(user.proft).toFixed(2)
                      }
                      displayType="text"
                      thousandSeparator={true}
                      prefix={"$"}
                    />
                  </td>
                  <td>
                    <NumberFormat
                      value={
                        Number.isInteger(Number(user.itemSale))
                          ? Number(user.itemSale)
                          : Number(user.itemSale).toFixed(2)
                      }
                      displayType="text"
                      thousandSeparator={true}
                      prefix={`${user.currency == "دۆلار" ? "$" : "IQD"}`}
                    />
                  </td>
                  <td style={{ border: "2px solid #f0ad4e" }}>
                    <NumberFormat
                      value={
                        user.currency == "دۆلار"
                          ? Number.isInteger(Number(user.itemPrice))
                            ? Number(user.itemPrice)
                            : Number(user.itemPrice).toFixed(2)
                          : user.is_Single
                          ? Number.isInteger(Number(user.singleSalePrice))
                            ? Number(user.singleSalePrice)
                            : Number(user.singleSalePrice).toFixed(2)
                          : Number.isInteger(Number(user.itemPriceDinar))
                          ? Number(user.itemPriceDinar)
                          : Number(user.itemPriceDinar).toFixed(2)
                      }
                      displayType="text"
                      thousandSeparator={true}
                      prefix={`${user.currency == "دۆلار" ? "$" : "IQD"}`}
                    />
                  </td>
                  <td style={{ border: "2px solid #f0ad4e" }}>
                    <NumberFormat
                      value={
                        Number.isInteger(
                          Number(_.multiply(user.itemSale, user.count))
                        )
                          ? Number(_.multiply(user.itemSale, user.count))
                          : Number(
                              _.multiply(user.itemSale, user.count)
                            ).toFixed(2)
                      }
                      displayType="text"
                      thousandSeparator={true}
                      prefix="$"
                    />
                  </td>
                  <td style={{ border: "2px solid #f0ad4e" }}>
                    <NumberFormat
                      value={
                        user.currency == "دینار"
                          ? Number.isInteger(
                              Number(_.multiply(user.itemCartonIQD, user.count))
                            )
                            ? Number(_.multiply(user.itemCartonIQD, user.count))
                            : Number(
                                _.multiply(user.itemCartonIQD, user.count)
                              ).toFixed(2)
                          : 0
                      }
                      displayType="text"
                      thousandSeparator={true}
                      prefix="IQD"
                    />
                  </td>
                  <td style={{ border: "2px solid #f0ad4e" }}>
                    <NumberFormat
                      value={
                        Number.isInteger(
                          Number(_.multiply(user.itemPrice, user.count))
                        )
                          ? Number(_.multiply(user.itemPrice, user.count))
                          : Number(
                              _.multiply(user.itemPrice, user.count)
                            ).toFixed(2)
                      }
                      displayType="text"
                      thousandSeparator={true}
                      prefix="$"
                    />
                  </td>
                  <td style={{ border: "2px solid #f0ad4e" }}>
                    {user.itemname}
                  </td>
                  <td style={{ border: "2px solid #f0ad4e" }}>
                    {user.itemcode}
                  </td>
                  <td
                    className={`fk ${
                      user.currency == "دۆلار" ? "text-success" : "text-danger"
                    }`}
                    style={{ border: "2px solid #f0ad4e" }}
                  >
                    {user.currency}
                  </td>
                  <td style={{ border: "2px solid #f0ad4e" }}>
                    <Time
                      value={user.date}
                      format="YYYY-MM-DD"
                      style={{ color: "black" }}
                    />
                  </td>
                  <td
                    onClick={(e) => {
                      D_gotowaslrentsearch(e, user.invoice, user.itemname);
                    }}
                    style={{ border: "2px solid #f0ad4e" }}
                  >
                    <Link to={"/rent"}>{user.invoice}</Link>
                  </td>
                </tr>
              );
            });

            return (
              <div className="RR_m">
                <table
                  id="example"
                  className="table table-hover table-bordered text-right"
                >
                  <thead>
                    <tr className="text-warning ">
                      <th style={{ border: "2px solid #f0ad4e" }}>کۆد</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        ناوی کڕیار
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>کارتۆن</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>قازانج</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        نرخی فرۆشتن
                      </th>
                      {/* <th style={{ border: "2px solid #f0ad4e" }}>IQDنرخ</th> */}
                      <th style={{ border: "2px solid #f0ad4e" }}>نرخ</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        $فرۆشتن کارتۆن
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        IQDفرۆشتن کارتۆن
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        $نرخ کارتۆن
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>ناوی کاڵا</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>ک.کاڵا</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>دراو</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>بەروار</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>پسولە</th>
                    </tr>
                  </thead>
                  <tbody>{qarzeWakel}</tbody>
                </table>
              </div>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
export default RozhanaMawadTable;
